/* Patient-lift component. Liquid supplies JSON; this asset owns behavior only. */
(() => {
  'use strict';
  let dispose = () => {
  };
  function initializePatientLift() {
    const root=document.getElementById('wl-hoyer-guide');
    if(!root||root.dataset.ready)return;
    dispose();
    root.dataset.ready='1';
    const controller=new AbortController();
    const signal=controller.signal;
    let priceObserver;
    const {
      variants, productName, sectionId, slingVariants
    } = JSON.parse(root.querySelector('[data-wl-config-json]').textContent);
    const info=document.getElementById('Product-'+sectionId);
    const price=document.getElementById('price-'+sectionId);
    const quote=root.querySelector('#wl-quote');
    const config=root.querySelector('#wl-config');
    function currentVariant(){
      const params=new URLSearchParams(location.search);
      return variants.find(v=>String(v.id)===params.get('variant'))||variants[0]
    } function configuration(){
      const v=currentVariant();
      let lines=[productName,'Model: '+(v.sku||v.title),'Lift price: '+new Intl.NumberFormat('en-US',{
        style:'currency',currency:'USD'
      }).format(v.price/100)];
      const dpo=document.getElementById('itoris_dynamicproductoptions');
      if(dpo){
        dpo.querySelectorAll('select').forEach(s=>{
          const o=s.selectedOptions[0];
          if(o&&o.value&&o.textContent&&!/Please Select/.test(o.textContent))lines.push(o.textContent.trim())
        });
        dpo.querySelectorAll('input:checked').forEach(i=>{
          const l=dpo.querySelector('label[for="'+i.id+'"]');
          if(l)lines.push(l.textContent.trim())
        })
      }lines.push('Product: '+location.href);
      config.value=lines.join('\n');
      root.querySelector('[data-wl-price]').textContent=new Intl.NumberFormat('en-US',{
        style:'currency',currency:'USD'
      }).format(v.price/100);
      subtotal()
    } root.querySelectorAll('[data-wl-quote]').forEach(a=>a.addEventListener('click',()=>{
      quote.open=true;
      configuration()
    }));
    quote.addEventListener('toggle',configuration);
    root.querySelector('[data-wl-buy]').addEventListener('click',()=>{
      const button=Array.from(info?.querySelectorAll('button')||[]).find(b=>b.textContent.includes('Customize and Buy'));
      if(button)button.click()
    });
    function navigation(){
      root.querySelectorAll('#wl-theme-policies collapsible-expandable').forEach(el=>{
        if(el.dataset.wlCopy)return;
        const name=el.querySelector('.facet-toggle')?.textContent.trim().toLowerCase();
        const oldIcon=el.querySelector('.facet-toggle > span:first-child svg');
        const iconTemplate=document.getElementById('wl-'+name+'-icon');
        if(oldIcon&&iconTemplate)oldIcon.replaceWith(iconTemplate.content.cloneNode(true));
        const template=document.getElementById(name==='shipping'?'wl-shipping-copy':'wl-returns-copy');
        const content=el.querySelector('.facet-content');
        if(template&&content){
          content.replaceChildren(template.content.cloneNode(true));
          el.dataset.wlCopy='1'
        }
      });
      const destination=root.querySelector('#wl-theme-policies');
      const page=document.getElementById('ProductPage-'+sectionId);
      page?.querySelectorAll('collapsible-expandable').forEach(el=>{
        if(root.contains(el))return;
        const title=el.querySelector('.facet-toggle')?.textContent.trim().toLowerCase();
        if(title==='shipping'||title==='returns'){
          const old=el.parentElement;
          destination.append(el);
          if(!old.textContent.trim())old.hidden=true
        }
      });
      const headings=Array.from(document.querySelectorAll('h2,h3'));
      const docs=headings.find(h=>/Manufacturer documents/i.test(h.textContent));
      const docLink=root.querySelector('[data-wl-docs]');
      if(docs){
        docs.id='wl-documents';
        docLink.hidden=false;
        docLink.textContent='Manuals'
      }const review=document.querySelector('.jdgm-widget.jdgm-review-widget');
      const reviewLink=root.querySelector('[data-wl-reviews]');
      if(review){
        reviewLink.href='#'+(review.id||'judgeme_product_reviews');
        reviewLink.hidden=false
      }document.querySelectorAll('iframe[src*="youtube"]').forEach(frame=>{
        if(frame.closest('.wl-hoyer'))return;
        const wrapper=frame.closest('.video-wrapper');
        if(!wrapper)return;
        const heading=wrapper.previousElementSibling;
        if(heading&&/^H[23]$/.test(heading.tagName)&&/demonstration|video/i.test(heading.textContent))heading.remove();
        root.querySelector('[data-wl-video]').append(wrapper);
        root.querySelector('#wl-watch').hidden=false
      })
    } function subtotal(){
      const dpo=document.getElementById('itoris_dynamicproductoptions');
      if(!dpo)return;
      let total=currentVariant().price/100;
      dpo.querySelectorAll('select').forEach(s=>{
        const o=s.selectedOptions[0];
        const p=Number(o?.getAttribute('price'))||0;
        const q=Number(document.getElementById(s.id+'_qty')?.value)||1;
        total+=p*q
      });
      dpo.querySelectorAll('input:checked').forEach(i=>total+=Number(i.getAttribute('price'))||0);
      let summary=dpo.querySelector('.wl-dpo-total');
      if(!summary){
        summary=document.createElement('p');
        summary.className='wl-dpo-total';
        summary.setAttribute('aria-live','polite');
        dpo.append(summary)
      }summary.textContent='Configuration subtotal (1 lift): '+new Intl.NumberFormat('en-US',{
        style:'currency',currency:'USD'
      }).format(total)+' — before discounts, tax and any additional shipping. Review final total in cart.';
      const lines=config.value.split('\n').filter(l=>!l.startsWith('Configuration subtotal'));
      config.value=lines.join('\n')+'\nConfiguration subtotal (1 lift): '+new Intl.NumberFormat('en-US',{
        style:'currency',currency:'USD'
      }).format(total)
    } function layout(){
      if(root.dataset.layout)return;
      const page=document.getElementById('ProductPage-'+sectionId);
      const card=root.querySelector('#wl-buying-summary');
      if(!page||!card)return;
      const quick=document.createElement('div');
      quick.className='wl-hoyer wl-quick-view';
      root.before(quick);
      quick.append(card);
      const grid=document.createElement('div');
      grid.className='wl-detail-grid';
      const left=document.createElement('div');
      const right=document.createElement('div');
      left.className=right.className='wl-detail-column';
      ['wl-watch','wl-sling-guide','wl-compare'].forEach(id=>{
        const el=root.querySelector('#'+id);
        if(el)left.append(el)
      });
      ['wl-faq','wl-theme-policies','wl-quote'].forEach(id=>{
        const el=root.querySelector('#'+id);
        if(el)right.append(el)
      });
      grid.append(left,right);
      root.querySelector('nav').after(grid);
      page.after(root);
      root.classList.add('wl-details-section');
      root.dataset.layout='1'
    } function enhance(){
      navigation();
      layout();
      const dpo=document.getElementById('itoris_dynamicproductoptions');
      if(!dpo)return;
      dpo.querySelectorAll('select').forEach(s=>{
        if(s.dataset.wlPreview)return;
        const matches=Array.from(s.options).some(o=>slingVariants.some(v=>v.sku&&v.sku===o.getAttribute('product-sku')));
        if(!matches)return;
        s.dataset.wlPreview='1';
        const preview=document.createElement('div');
        preview.className='wl-dpo-preview';
        const img=document.createElement('img');
        const text=document.createElement('span');
        preview.append(img,text);
        s.after(preview);
        function update(){
          const o=s.selectedOptions[0];
          const v=slingVariants.find(v=>v.sku===o?.getAttribute('product-sku'));
          if(v){
            img.src=v.image;
            img.alt=v.title;
            img.hidden=false;
            text.textContent=v.title
          }else{
            img.hidden=true;
            text.textContent='Choose a style and size to preview the sling.'
          }
        }s.addEventListener('change',update);
        update()
      });
      subtotal()
    } root.querySelectorAll('nav a').forEach(a=>a.addEventListener('click',()=>{
      const id=a.getAttribute('href')?.slice(1);
      const target=id&&document.getElementById(id);
      if(target?.tagName==='DETAILS')target.open=true
    }));
    document.addEventListener('change',event=>{
      const i=event.target;
      if(i.type!=='checkbox'||!i.checked||!i.closest('#itoris_dynamicproductoptions'))return;
      const group=i.closest('.options-list');
      if(!group)return;
      const label=group.closest('.control')?.previousElementSibling;
      if(!label?.textContent.includes('Delivery'))return;
      group.querySelectorAll('input[type="checkbox"]:checked').forEach(other=>{
        if(other!==i){
          other.checked=false;
          other.dispatchEvent(new Event('change',{
            bubbles:true
          }))
        }
      })
    } ,{
      signal
    });
    document.addEventListener('change',()=>setTimeout(configuration,100),{
      signal
    });
    if(price){
      priceObserver=new MutationObserver(configuration);
      priceObserver.observe(price,{
        childList:true,subtree:true,characterData:true
      })
    }const timer=setInterval(enhance,1000);
    const stopTimer=setTimeout(()=>clearInterval(timer),60000);
    dispose=()=>{
      controller.abort();
      priceObserver?.disconnect();
      clearInterval(timer);
      clearTimeout(stopTimer)
    };
    document.addEventListener('input',e=>{
      if(e.target.closest('#itoris_dynamicproductoptions'))configuration()
    },{
      signal
    });
    configuration();
    enhance();
    if(location.hash==='#WlHoyerQuote'||location.search.includes('contact_posted'))quote.open=true;
  } initializePatientLift();
  document.addEventListener('shopify:section:load',initializePatientLift);
  document.addEventListener('shopify:section:unload',()=>{
    if(!document.getElementById('wl-hoyer-guide')?.isConnected)dispose()
  });
})();
